import type { DecisionEngineDestinationUI } from "src/pages/decision-engines/destination-ui/definition";

export const webhookUI: DecisionEngineDestinationUI = {
  campaignSetup: "freeform",
  resourceName: "resource",
  channelDescription: "Webhook",
  getReferenceString: (reference) => `{{ ${reference} }}`,
  isPreviewSupported: false,
  isTestSendSupported: (config) => Boolean(config.externalId?.trim()),
};
